import { language } from "@/language";
import React, { useContext, createContext } from "react";
const TranslationContext = createContext();

export function useTranslation() {
  return useContext(TranslationContext);
}

export function TranslationProvider({ children }) {
  return (
    <TranslationContext.Provider value={language}>
      {children}
    </TranslationContext.Provider>
  );
}
